export default {
  addbanner: {
    badge: "Limited Offer",
    cta: "Shop Now",

    title1: "Up to 50% off on Special Item",
    desc1: "Shop our selection of organic fresh vegetables at discounted prices.",

    title2: "Get 10% off on Fruits Item",
    desc2: "Enjoy fresh fruits with special seasonal discounts.",

    title3: "Get 75% Organic Vegetable",
    desc3: "Buy organic vegetables at unbeatable prices.",
  },
};